(function initGGAnnouncementSticky() {
    const banner = document.querySelector('.gg-announcement-banner');
    if (!banner) return;

    const root = document.documentElement;
    const body = document.body;
    let lastHidden = null;

    const applyState = () => {
        const y = window.scrollY || 0;
        const currentlyHidden = body.classList.contains('gg-announcement-hidden');
        const hideBanner = currentlyHidden ? y > 8 : y > 24;
        if (lastHidden === hideBanner) return;
        lastHidden = hideBanner;
        body.classList.toggle('gg-announcement-hidden', hideBanner);
        const fullHeight = Math.round(banner.getBoundingClientRect().height || 0);
        const visibleHeight = hideBanner ? 0 : fullHeight;
        root.style.setProperty('--gg-announcement-height', `${fullHeight}px`);
        root.style.setProperty('--gg-announcement-visible-height', `${visibleHeight}px`);
        root.style.setProperty('--gg-header-top-offset', `${visibleHeight}px`);
    };

    window.addEventListener('scroll', applyState, { passive: true });
    window.addEventListener('resize', () => { lastHidden = null; applyState(); });
    window.addEventListener('load', () => { lastHidden = null; applyState(); });
    applyState();
})();

(function initTimer() {
    if (timerSeconds) {
        const timerLength = timerSeconds * 1000;
        let now = Date.parse(new Date());
        let firstLanding;
        if (localStorage.getItem('firstLanding')) {
            firstLanding = Number(localStorage.getItem('firstLanding'));
        } else {
            firstLanding = now;
            localStorage.setItem('firstLanding', firstLanding);
        }
        const outerDiv = document.querySelector('.gg-announcement-banner');
        let openingDivDesk = outerDiv.querySelector('#unTimedDesk') ? outerDiv.querySelector('#unTimedDesk') : outerDiv.querySelector('#unTimedText') ? outerDiv.querySelector('#unTimedText') : false;
        let openingDivMob = outerDiv.querySelector('#unTimedMob') ? outerDiv.querySelector('#unTimedMob') : outerDiv.querySelector('#unTimedText') ? outerDiv.querySelector('#unTimedText') : false;
        let closingDivDesk = outerDiv.querySelector('#timedDesk') ? outerDiv.querySelector('#timedDesk') : outerDiv.querySelector('#timedText') ? outerDiv.querySelector('#timedText') : false;
        let closingDivMob = outerDiv.querySelector('#timedMob') ? outerDiv.querySelector('#timedMob') : outerDiv.querySelector('#timedText') ? outerDiv.querySelector('#timedText') : false;
        if (timerLength > now - firstLanding && (openingDivDesk || openingDivMob)) {
            if (openingDivDesk) {
                openingDivDesk.classList.remove('timerHidden');
            }
            if (openingDivMob) {
                openingDivMob.classList.remove('timerHidden');
            }
            if (closingDivDesk || closingDivMob) {
                setTimeout(() => {
                    if (openingDivDesk) {
                        openingDivDesk.classList.add('timerHidden');
                    }
                    if (openingDivMob) {
                        openingDivMob.classList.add('timerHidden');
                    }
                    if (closingDivDesk) {
                        closingDivDesk.classList.remove('timerHidden');
                    }
                    if (closingDivMob) {
                        closingDivMob.classList.remove('timerHidden');
                    }
                    setTimeout(() => {
                        localStorage.removeItem('firstLanding');
                    }, timerLength);
                }, (timerLength - (now - firstLanding)));
            }
        } else if (closingDivDesk || closingDivMob) {
            closingDivDesk.classList.remove('timerHidden');
            closingDivMob.classList.remove('timerHidden');
            localStorage.removeItem('firstLanding');
        }
    }
})();